// extracted by mini-css-extract-plugin
export default {"ButtonBgColor":"Button_ButtonBgColor__BjIxO","ButtonBoxShadow":"Button_ButtonBoxShadow__Kiyh0"};